import React from "react";

/**
 * Granola-style sidebar panel glyph with open/closed variants.
 * - Closed (`collapsed`): hollow rounded frame + thin left divider
 * - Open: same frame with the left rail filled
 *
 * @example
 * <BusinessSidebarRailToggleIcon collapsed />
 * // Hollow outline — sidebar is hidden
 *
 * @example
 * <BusinessSidebarRailToggleIcon collapsed={false} />
 * // Left rail filled — sidebar is visible
 */
const BusinessSidebarRailToggleIcon = ({ collapsed = false }) => (
  <span className="business-sidebar-toggle-glyph" aria-hidden="true">
    <svg
      className={`business-sidebar-toggle-glyph__panel${
        collapsed
          ? " business-sidebar-toggle-glyph__panel--closed"
          : " business-sidebar-toggle-glyph__panel--open"
      }`}
      viewBox="0 0 16 14"
      width="15"
      height="13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* Outer frame */}
      <rect
        x="1"
        y="1"
        width="14"
        height="12"
        rx="2.25"
        ry="2.25"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      {collapsed ? (
        /* Closed: thin divider only — no filled pane */
        <path
          d="M4.75 2.75v8.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
        />
      ) : (
        /* Open: solid left rail (inset so it sits inside the stroke frame) */
        <rect
          className="business-sidebar-toggle-glyph__rail"
          x="2.15"
          y="2.15"
          width="2.6"
          height="9.7"
          rx="0.6"
          ry="0.6"
          fill="currentColor"
          stroke="none"
        />
      )}
    </svg>
  </span>
);

export default BusinessSidebarRailToggleIcon;
